module.exports = __webpack_public_path__ + "img/JDIH.198a8bab.png";